import API, { responseOf } from "./base";

export const getAllMetricsForDashboard = (
  dashboardId: string,
  startDate?: Date,
  endDate?: Date,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> =>
  responseOf(
    API.get(`/metrics/${dashboardId}`, {
      params: {
        startDate: startDate?.toISOString(),
        endDate: endDate?.toISOString(),
      },
      public: true,
    }),
  );
